module.exports = __webpack_public_path__ + "static/media/Agenda10.4ab20f26.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/Agenda/Agenda10.png
// module id = 1975
// module chunks = 0